import React from 'react'
import { useAppKit, useAppKitState } from '@reown/appkit/react'
import { SlButton } from '@shoelace-style/shoelace/dist/react'
import { useTranslation } from 'contexts/Localization'

const ConnectWalletButton = (props) => {
  const { t } = useTranslation()
  const { open } = useAppKit()
  const { open: isOpen } = useAppKitState()

  return (
    <SlButton variant="primary" onClick={open} loading={isOpen} {...props}>
      {t('Connect Wallet')}
    </SlButton>
  )
}

export default ConnectWalletButton
